var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#F8F9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.5769V16.5625C6.25 16.7219 6.19606 16.8554 6.08819 16.9632C5.98031 17.0711 5.84669 17.125 5.68731 17.125C5.52781 17.125 5.39425 17.0711 5.28662 16.9632C5.17887 16.8554 5.125 16.7219 5.125 16.5625V4.303C5.125 4.11087 5.19 3.94988 5.32 3.82C5.44987 3.69 5.61088 3.625 5.803 3.625H15.3336C15.4567 3.625 15.5676 3.6535 15.6662 3.7105C15.765 3.76737 15.8434 3.84138 15.9014 3.9325C15.9594 4.02363 15.9954 4.125 16.0094 4.23662C16.0232 4.34812 16.0046 4.46188 15.9533 4.57788L14.839 7.10106L15.9533 9.62406C16.0046 9.74006 16.0232 9.85381 16.0094 9.96531C15.9954 10.0769 15.9594 10.1783 15.9014 10.2694C15.8434 10.3606 15.765 10.4346 15.6662 10.4914C15.5676 10.5484 15.4567 10.5769 15.3336 10.5769H6.25ZM6.25 9.45194H14.6746L13.8625 7.64913C13.7827 7.4785 13.7429 7.29569 13.7429 7.10069C13.7429 6.90569 13.7827 6.72306 13.8625 6.55281L14.6746 4.75H6.25V9.45194Z",
    fill: "#0064E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.8703bea5eecb55e029790bcb44133f2b.svg";
export { ForwardRef as ReactComponent };